/**
 * Small fire-and-forget beacon that pushes PWA install-adoption events into
 * the existing experiments pipeline (`/api/experiments/event`).
 *
 * `key` is fixed to "pwa_install" so ops can filter for adoption analytics
 * with a single query. `variant` records the surface that triggered the
 * event: "web_prompt" or "ios_guide".
 *
 * Never throws — install-adoption analytics must never break the UI.
 */
const KEY = "pwa_install";
const SESSION_KEY = "advoset:pwa:analyticsSession";

function _session() {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch (_) { return ""; }
}

function _backendUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL || "";
  return raw.replace(/\/+$/, "");
}

export function trackInstallEvent(event, variant = "web_prompt") {
  try {
    const url = `${_backendUrl()}/api/experiments/event`;
    const payload = JSON.stringify({
      key: KEY,
      variant,
      event,
      session: _session(),
    });
    // Prefer sendBeacon so the event survives page-close (crucial for app_installed).
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }
    // Fallback: fire-and-forget fetch. keepalive lets the browser flush it
    // even during unload.
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  } catch (_) { /* analytics is best-effort */ }
}
